

































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { DeleteExams$ } from "@/request/jxgl";
@Component({})
export default class KsglExamList extends Vue {
  @Prop()
  private exams;
  @Prop()
  private filters;
  private selectChange(value, row) {
    this.$emit("selectChange", value, row);
  }
  /**
   * @description 编辑
   */
  private compose(row) {
    this.$router.push({
      path: "/main/jxgl/ksgl-detail",
      query: {
        id: row["exam_id"],
      },
    });
  }
  /**
   * @description 成绩查询
   */
  private check(row) {
    localStorage.setItem(
      "ksglResultFilters",
      JSON.stringify({
        search: "",
        current_page: 1,
        total_count: 0,
        page_count: 10,
        order_value: 0,
      })
    );
    this.$router.push({
      path: "/main/jxgl/ksgl-result-list",
      query: {
        id: row["exam_id"],
      },
    });
  }
  /**
   * @description 跳转考试统计
   */
  private analysis(row) {
    this.$router.push({
      path: "/main/jxgl/ksgl-analysis",
      query: {
        id: row["exam_id"],
      },
    });
  }
  /**
   * @description 删除
   */
  private deleteThis(row) {
    this.$confirm("删除后将无法找回，您确定要删除么？", {
      title: "温馨提示",
    })
      .then((value) => {
        const params: any = {
          data: {
            exam_ids: [row["exam_id"]],
          },
        };
        DeleteExams$(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.$emit("deleteDone");
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }
}
